import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaSearch,
  FaMicrophone,
  FaUser,
  FaArrowLeft,
  FaArrowRight,
} from "react-icons/fa";
import "./HeroSection.css";

const cards = [
  {
    title: "Krishna Hospital",
    description: "Up to 50% Off on Health Checkups & Dental Services",
    image:
      "https://images.unsplash.com/photo-1586773860418-d37222d8fce3?auto=format&fit=crop&w=800&q=80",
  },
  {
    title: "Restaurants",
    description: "Flat 50% Off on top restaurants",
    image:
      "https://images.unsplash.com/photo-1551218808-94e220e084d2?auto=format&fit=crop&w=800&q=80",
  },
  {
    title: "Retail",
    description: "Buy 1 Get 1 Free in top stores",
    image:
      "https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=800&q=80",
  },
  {
    title: "Spa & Wellness",
    description: "Up to 40% Off on spa services",
    image:
      "https://images.unsplash.com/photo-1600891964599-f61ba0e24092?auto=format&fit=crop&w=800&q=80",
  },
];

const HeroSection = () => {
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 1200);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 1200);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Auto-slide carousel every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % cards.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const prevCard = () => setIndex((index - 1 + cards.length) % cards.length);
  const nextCard = () => setIndex((index + 1) % cards.length);

  const handleSearch = (e) => {
    e.preventDefault();
    navigate(`/deals?search=${searchQuery}`);
  };

  return (
    <div className="header-hero-wrapper">
      {/* HEADER */}
      <header className="header">
        <div className="logo">
          <img src="/logo.png" alt="DiscountDost Logo" className="logo-img" />
          <span className="logo-text">DiscountDost</span>
        </div>
        <nav className="nav-links">
          <div className="dropdown">
            <div className="dropdown-title">Category</div>
            <div className="dropdown-menu">
              <Link to="/deals?category=Restaurants">Restaurants</Link>
              <Link to="/deals?category=Retail">Retail</Link>
              <Link to="/deals?category=Entertainment">Entertainment</Link>
              <Link to="/deals?category=Spa & Wellness">Spa & Wellness</Link>
              <Link to="/deals?category=Health">Health Services</Link>
              <Link to="/dashboard" className="dashboard-link">
                Dashboard
              </Link>
            </div>
          </div>
          

          {!isSmallScreen ? (
            <>
            <div className="dropdown">
            <div className="dropdown-title">Deals</div>
            <div className="dropdown-menu">
              <Link to="/deals">Exclusive Deals</Link>
              <Link to="/deals">All Deals</Link>
              </div>
              </div>
              <Link to="/partner-with-us">Partner with us</Link>
            </>
          ) : (
            <div className="dropdown">
              <div className="dropdown-title">Deals</div>
              <div className="dropdown-menu">
                <Link to="/deals">Exclusive Deals</Link>
                <Link to="/deals">All Deals</Link>
                <Link to="/partner-with-us">Partner with us</Link>
              </div>
            </div>
          )}

          <form className="search-form" onSubmit={handleSearch}>
            <button type="submit" className="icon-button">
              <FaSearch />
            </button>
            <input
              type="text"
              placeholder="search deals"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              autoFocus
            />
            <button type="button" className="icon-button">
              <FaMicrophone />
            </button>
          </form>
        </nav>

        <div className="icons">
            <div className="dropdown-title-gold">
            <Link to="/gold">Gold</Link>
          </div>
          <Link to="/login" className="user-icon login-button">
            <div className="login-icon">
              <FaUser />
            </div>
            <span className="login-text">Log in</span>
          </Link>
        </div>
      </header>

      {/* HERO */}
      <section className="hero-section">
        <div className="hero-left">
          <h1>
            Unlock Exclusive Discounts on India's Best Products<br/> & Services,
            Instantly!
          </h1>
          <p>Trusted by 50,000+ Smart Shoppers Nationwide.</p>
          <p>
            Sign up today and immediately access insider deals and<br/> hidden
            discounts specially curated just for you.
          </p>
          <div className="hero-buttons">
            <Link to="/deals" className="primary-btn">
              Browse Deals
            </Link>
          </div>
        </div>

        <div className="hero-right">
          <div className="carousel-box">
            <button className="carousel-btn left" onClick={prevCard}>
              <FaArrowLeft />
            </button>
            <div className="deal-image-wrapper">
              <img
                src={cards[index].image}
                alt={cards[index].title}
                className="carousel-image"
              />
              <div className="deal-overlay">
                <h3>{cards[index].title}</h3>
                <p>{cards[index].description}</p>
                <Link
                  to={`/deals?category=${cards[index].title}`}
                  className="view-deal"
                >
                  View Deal
                </Link>
              </div>
            </div>
            <button className="carousel-btn right" onClick={nextCard}>
              <FaArrowRight />
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HeroSection;
